var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 114") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: 22,
    transform: "translate(-91.000000, -593.000000)",
    stroke: "#6490F1",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-118",
    transform: "translate(92.000000, 593.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-114",
    transform: "translate(0.954875, 0.440039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.54512532,2.71618846 L9.54512532,1 C9.54512532,0.44771525 9.09741007,3.45126062e-15 8.54512532,3.55271368e-15 L1,3.55271368e-15 C0.44771525,3.65416674e-15 -6.76353751e-17,0.44771525 0,1 L0,8.64954448 C6.76353751e-17,9.20182923 0.44771525,9.64954448 1,9.64954448 L4.40731047,9.64954448 L4.40731047,9.64954448",
    id: "\\u8DEF\\u5F84-139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77256266,4.82477224 L12.9345964,4.82477224 C13.4868812,4.82477224 13.9345964,5.27248749 13.9345964,5.82477224 L13.9345964,13.3966946 C13.9345964,13.9489794 13.4868812,14.3966946 12.9345964,14.3966946 L5.77256266,14.3966946 C5.22027791,14.3966946 4.77256266,13.9489794 4.77256266,13.3966946 L4.77256266,5.82477224 C4.77256266,5.27248749 5.22027791,4.82477224 5.77256266,4.82477224 Z",
    id: "\\u8DEF\\u5F84-140"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.2a15f828871ea8c392d4a9ab51a9da8a.svg";
export { ForwardRef as ReactComponent };